import { accountKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useApi } from '@/app/api'
import { accountLabelIndex } from '../internal/account-options.ts'

export interface UseTargetAccountLabelsOptions {
  readonly ledgerId: () => string | undefined
  readonly enabled: () => boolean
}

export function useTargetAccountLabels(options: UseTargetAccountLabelsOptions) {
  const api = useApi()
  const { locale } = useI18n()
  const active = computed(() => options.enabled() && options.ledgerId() !== undefined)

  const treeQuery = useQuery({
    queryKey: computed(() => accountKeys.tree(options.ledgerId() ?? '')),
    queryFn: ({ signal }) => api.accounts.tree(options.ledgerId()!, signal),
    enabled: active,
  })

  const labels = computed(() => accountLabelIndex(treeQuery.data.value ?? [], locale.value as 'en' | 'hu'))

  return { labelOf: (accountId: string): string | undefined => labels.value.get(accountId) }
}
